import { INPUT_VARIANT } from "../const";
import { FormControl } from "../styles";
import { useClientParamBool } from "@/hooks/useClientParam";

// Mirrors ASP: inputs are CSS-uppercased (INPUT.FormTextBox) unless the field is
// flagged MixedCase. Display only - the typed/saved value is never changed.
// Enabled per client via Globals / UppercaseDisplay (default False).
//
// Applied as the $forceUppercase class on FormControl (styles.js), not a
// plain inline style — a field whose Form.Item sets hasFeedback (e.g. the
// Address1/Apt# fields in AddressesForm.jsx) gets specially cloned by antd
// to make room for the validation icon, which was silently dropping a
// plain inline style passed here. The stylesheet !important rule survives
// that regardless of how antd clones/reorders props.
const TextField = ({ id, name, label, inputType = "", variant, required, mixedCase = false, style, ...rest }) => {
  const uppercaseDisplay = useClientParamBool("Globals", "UppercaseDisplay", false);
  const forceUppercase = uppercaseDisplay && !mixedCase && inputType !== "password";
  if (style) rest.style = style;
  return (
    <>
      {inputType === "" && rest.as !== "textarea" && (
        <FormControl id={id} name={name} className={`${rest?.className}`} variant={variant} $forceUppercase={forceUppercase} {...rest} />
      )}
      {inputType === "password" && (
        <FormControl.Password id={id} name={name} className={`${rest?.className}`} variant={variant}  {...rest} />
      )}
      {(inputType === "textarea" || rest.as === "textarea") && (
        <FormControl.TextArea id={id} name={name} className={`${rest?.className}`} variant={variant} $forceUppercase={forceUppercase} {...rest} />
      )}
    </>
  );
};

export default TextField;
